import { Text } from '../Text';
import {
	StyledContainer,
	StyledHeadContainer,
	StyledDivider,
} from './ShopHead.styled';

interface IShopHeadProps {
	img: string;
	text: string;
	height: number;
}
const ShopHead = ({ img, text, height }: IShopHeadProps) => {
	return (
		<StyledContainer $gap={60 - height}>
			<StyledHeadContainer>
				<img src={img} height={height} />
				<Text>{text}</Text>
			</StyledHeadContainer>
			<StyledDivider />
		</StyledContainer>
	);
};

export { ShopHead };
